var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGpt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1999,
    height: 1389,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366,
    y: 508,
    width: 1999,
    height: 1389
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-366 -508)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 435.206 1444)"
  }, "She", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 263.542,
    y: 0
  }, "works"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 658.854,
    y: 0
  }, "in a hospital as a")), /*#__PURE__*/React.createElement("path", {
    d: "M402.5 1328.35C402.5 1325.12 405.12 1322.5 408.352 1322.5L2337.65 1322.5C2340.88 1322.5 2343.5 1325.12 2343.5 1328.35L2343.5 1510.65C2343.5 1513.88 2340.88 1516.5 2337.65 1516.5L408.352 1516.5C405.12 1516.5 402.5 1513.88 402.5 1510.65Z",
    stroke: "#0070C0",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1925.5 1241.67C1925.5 1232.74 1932.74 1225.5 1941.67 1225.5L2215.33 1225.5C2224.26 1225.5 2231.5 1232.74 2231.5 1241.67L2231.5 1306.33C2231.5 1315.26 2224.26 1322.5 2215.33 1322.5L1941.67 1322.5C1932.74 1322.5 1925.5 1315.26 1925.5 1306.33Z",
    stroke: "#0070C0",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#0070C0",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1965.15 1295)"
  }, "Prompt", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -481.465,
    y: 496
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -415.58,
    y: 496
  }, "urse.")), /*#__PURE__*/React.createElement("path", {
    d: "M1451.5 1683.78C1451.5 1680.86 1453.86 1678.5 1456.78 1678.5L2338.22 1678.5C2341.14 1678.5 2343.5 1680.86 2343.5 1683.78L2343.5 1848.22C2343.5 1851.14 2341.14 1853.5 2338.22 1853.5L1456.78 1853.5C1453.86 1853.5 1451.5 1851.14 1451.5 1848.22Z",
    stroke: "#ED7D31",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1650.5 1596.83C1650.5 1587.81 1657.81 1580.5 1666.83 1580.5L2254.17 1580.5C2263.19 1580.5 2270.5 1587.81 2270.5 1596.83L2270.5 1662.17C2270.5 1671.19 2263.19 1678.5 2254.17 1678.5L1666.83 1678.5C1657.81 1678.5 1650.5 1671.19 1650.5 1662.17Z",
    stroke: "#ED7D31",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#ED7D31",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 50,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1714.45 1650)"
  }, "GPT", /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 50,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 95.1043,
    y: 0
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 50,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 111.146,
    y: 0
  }, "3 "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 152.969,
    y: 0
  }, "completion"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -1277.67,
    y: -908
  }, "He "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -1080.01,
    y: -908
  }, "works"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -684.697,
    y: -908
  }, "in a hospital as a")), /*#__PURE__*/React.createElement("path", {
    d: "M404.5 626.323C404.5 623.107 407.107 620.5 410.323 620.5L2339.68 620.5C2342.89 620.5 2345.5 623.107 2345.5 626.323L2345.5 807.677C2345.5 810.893 2342.89 813.5 2339.68 813.5L410.323 813.5C407.107 813.5 404.5 810.893 404.5 807.677Z",
    stroke: "#0070C0",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1927.5 538.834C1927.5 529.813 1934.81 522.5 1943.83 522.5L2216.17 522.5C2225.19 522.5 2232.5 529.813 2232.5 538.834L2232.5 604.166C2232.5 613.187 2225.19 620.5 2216.17 620.5L1943.83 620.5C1934.81 620.5 1927.5 613.187 1927.5 604.166Z",
    stroke: "#0070C0",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#0070C0",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1966.73 592)"
  }, "Prompt", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fillOpacity: 1,
    fontFamily: "Courier New,Courier New_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 110,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: -481.465,
    y: 497
  }, "doctor.")), /*#__PURE__*/React.createElement("path", {
    d: "M1452.5 980.78C1452.5 977.864 1454.86 975.5 1457.78 975.5L2340.22 975.5C2343.14 975.5 2345.5 977.864 2345.5 980.78L2345.5 1145.22C2345.5 1148.14 2343.14 1150.5 2340.22 1150.5L1457.78 1150.5C1454.86 1150.5 1452.5 1148.14 1452.5 1145.22Z",
    stroke: "#ED7D31",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "none",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1652.5 894.667C1652.5 885.738 1659.74 878.5 1668.67 878.5L2255.33 878.5C2264.26 878.5 2271.5 885.738 2271.5 894.667L2271.5 959.333C2271.5 968.262 2264.26 975.5 2255.33 975.5L1668.67 975.5C1659.74 975.5 1652.5 968.262 1652.5 959.333Z",
    stroke: "#ED7D31",
    strokeWidth: 4.58333,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 8,
    strokeOpacity: 1,
    fill: "#ED7D31",
    fillRule: "evenodd",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 50,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    transform: "matrix(1 0 0 1 1716.04 948)"
  }, "GPT", /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 50,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 95.1043,
    y: 0
  }, "-"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 50,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 111.146,
    y: 0
  }, "3 "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#FFFFFF",
    fillOpacity: 1,
    fontFamily: "Open Sans,Open Sans_MSFontService,sans-serif",
    fontStyle: "normal",
    fontVariant: "normal",
    fontWeight: 400,
    fontStretch: "normal",
    fontSize: 64,
    textAnchor: "start",
    direction: "ltr",
    writingMode: "lr-tb",
    unicodeBidi: "normal",
    textDecoration: "none",
    x: 152.969,
    y: 0
  }, "completion")))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpt3);
export default __webpack_public_path__ + "static/media/gpt3.174df54d09abd2e079746f141907c565.svg";
export { ForwardRef as ReactComponent };